export * from 'af-actions/scheduleBoard/scheduleBoard.actions';
import type { ScheduleBoardAction as ScheduleBoardActionImport } from 'af-actions/scheduleBoard/scheduleBoard.actionCreators';

export type ScheduleBoardAction = ScheduleBoardActionImport;
